"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactColor = require("react-color");

var _index = require("../index");

var _validatecolor = require("../../utils/validatecolor");

var _reactJss = _interopRequireDefault(require("react-jss"));

var _colorpicker_styles = _interopRequireDefault(require("./colorpicker_styles"));

var _colorpicker_definition = _interopRequireDefault(require("./colorpicker_definition"));

var _definecomponent = require("../../utils/definecomponent");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};

  if (obj != null) {
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}
/* ========== ~~~~~~~~~~ EXPORT : COLOR PICKER ~~~~~~~~~~ ========== */


var ColorPicker =
/*#__PURE__*/
function (_Component) {
  _inherits(ColorPicker, _Component);

  function ColorPicker(props) {
    var _this;

    _classCallCheck(this, ColorPicker);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ColorPicker).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "handleFieldBlur", function (e) {
      var colorValid = (0, _validatecolor.validateColor)(e.target.value);

      _this.props.validateColor(colorValid);

      if (colorValid) _this.props.processColorUpdate(e.target.value);
    });

    _defineProperty(_assertThisInitialized(_this), "handleFieldChange", function (e) {
      _this.setState({
        fieldValue: e.target.value
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleChangeComplete", function (color) {
      _this.props.processColorUpdate(color.hex);

      _this.props.validateColor(true);
    });

    _defineProperty(_assertThisInitialized(_this), "handleReset", function (e) {
      _this.props.handleReset();

      _this.setState({
        fieldValue: _this.props.savedColor
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleKeyDown", function (e) {
      if (e.key === 'Enter') {
        _this.handleFieldBlur(e);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "displayColorPicker", function () {
      document.addEventListener('mousedown', _this.handleOutsideClick, false);

      _this.setState({
        picker: 'active'
      });
    });

    _defineProperty(_assertThisInitialized(_this), "closeColorPicker", function () {
      _this.setState({
        picker: 'inactive'
      });

      document.removeEventListener('mousedown', _this.handleOutsideClick, false);
    });

    _defineProperty(_assertThisInitialized(_this), "handleOutsideClick", function (e) {
      // ignore clicks on the component itself
      if (_this.node.contains(e.target)) {
        return;
      }

      _this.closeColorPicker();
    });

    _this.state = {
      picker: 'inactive',
      fieldValue: _this.props.color ? _this.props.color : '#cccccc',
      savedColor: _this.props.color ? _this.props.color : '#cccccc'
    };
    return _this;
  }

  _createClass(ColorPicker, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.color !== this.props.color || !prevProps.valid && prevProps.valid !== this.props.valid) {
        this.setState({
          fieldValue: this.props.color
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          color = _this$props.color,
          valid = _this$props.valid,
          savedColor = _this$props.savedColor;
      var fieldColor = this.state.fieldValue;
      return _react.default.createElement("div", {
        className: "colorpicker ".concat(this.props.classes.colorpicker)
      }, _react.default.createElement("div", {
        className: 'colorpickerlabel'
      }, _react.default.createElement("span", null, this.props.label), _react.default.createElement("div", {
        className: "reset",
        onClick: this.handleReset,
        style: {
          display: valid && color.toUpperCase() === savedColor.toUpperCase() ? 'none' : 'block'
        }
      }, "Reset")), _react.default.createElement("div", {
        className: "currentcolor"
      }, _react.default.createElement("span", {
        className: "swatch",
        style: {
          background: color
        },
        onClick: this.displayColorPicker
      }), _react.default.createElement(_index.TextField, {
        klass: 'colortext',
        validateColor: valid,
        valid: valid,
        handleChange: this.handleFieldChange,
        type: "text",
        value: fieldColor,
        handleBlur: this.handleFieldBlur,
        handleKeyDown: this.handleKeyDown
      }), _react.default.createElement("div", {
        className: 'invalidColor',
        style: {
          display: valid ? 'none' : 'block'
        }
      }, "Not a valid color")), _react.default.createElement("div", {
        className: "picker ".concat(this.state.picker),
        ref: function ref(node) {
          _this2.node = node;
        }
      }, _react.default.createElement(_reactColor.ChromePicker, {
        color: color,
        onChangeComplete: this.handleChangeComplete,
        disableAlpha: true
      }), _react.default.createElement(_index.Button, {
        type: "custom",
        handleClick: this.closeColorPicker,
        variant: "primary",
        name: "close",
        text: "Apply Color"
      })));
    }
  }]);

  return ColorPicker;
}(_react.Component);

;
(0, _definecomponent.defineComponent)(ColorPicker, _colorpicker_definition.default, false);
/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */

var _default = (0, _reactJss.default)(_colorpicker_styles.default)(ColorPicker);

exports.default = _default;